import { NavLink } from "react-router-dom";
import { useState } from "react";
import Box from "@mui/material/Box";
import IconButton from "@mui/material/IconButton";
import Button from "@mui/material/Button";
import { Menu, X } from "lucide-react";

const ASSET_BASE = process.env.PUBLIC_URL || "";

const navItems = [
  { label: "Home", to: "/home" },
  { label: "Careers", to: "/careers" },
  { label: "Blogs", to: "/blogs" },
  { label: "About Us", to: "/about" },
];

function Header() {
  const [menuOpen, setMenuOpen] = useState(false);
  const toggle = () => setMenuOpen((o) => !o);
  const close = () => setMenuOpen(false);

  return (
    <Box
      component="header"
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        minHeight: { xs: 80, md: 130 },
        px: { xs: 2, md: 4 },
        bgcolor: "common.white",
        position: "fixed",
        top: 0,
        left: 0,
        width: "100%",
        zIndex: 9999,
        borderBottom: "1px solid",
        borderColor: "grey.200",
        boxShadow: "0px 2px 4px rgba(0,0,0,0.02)",
      }}
    >
      <NavLink to="/home" aria-label="Go to home">
        <Box
          component="img"
          src={`${ASSET_BASE}/assets/logo.png`}
          alt="Anko Sourcing logo"
          sx={{
            height: { xs: 50, md: 75 },
            width: "auto",
            ml: { xs: 0, md: "50px" },
          }}
        />
      </NavLink>

      <IconButton
        onClick={toggle}
        aria-label="Toggle menu"
        sx={{
          display: { md: "none" },
          color: "primary.main",
          zIndex: 10001,
        }}
      >
        {menuOpen ? <X size={28} /> : <Menu size={28} />}
      </IconButton>

      <Box
        sx={{
          display: { xs: menuOpen ? "flex" : "none", md: "flex" },
          position: { xs: "fixed", md: "static" },
          top: { xs: 80 },
          left: 0,
          right: 0,
          flexDirection: { xs: "column", md: "row" },
          alignItems: "center",
          gap: { xs: 3, md: 3.5 },
          bgcolor: { xs: "common.white", md: "transparent" },
          p: { xs: "2rem 1.5rem", md: 0 },
          boxShadow: { xs: "0 4px 12px rgba(0,0,0,0.1)", md: "none" },
          zIndex: 10000,
          ml: { md: "auto" },
          mr: { md: "20px" },
        }}
      >
        <Box
          component="nav"
          sx={{
            display: "flex",
            flexDirection: { xs: "column", md: "row" },
            alignItems: "center",
            gap: { xs: 3, md: 4 },
          }}
        >
          {navItems.map((item) => (
            <Box
              key={item.to}
              component={NavLink}
              to={item.to}
              onClick={close}
              sx={{
                textDecoration: "none",
                color: "primary.main",
                fontSize: { xs: "1.1rem", md: "18.5px" },
                fontWeight: 500,
                transition: "color 0.2s",
                "&.active": { color: "#1b1f24" },
                "&:hover": { color: "#000000" },
                textAlign: "center",
                py: { xs: 0.5, md: 0 },
              }}
            >
              {item.label}
            </Box>
          ))}
        </Box>

        <Button
          component={NavLink}
          to="/contact"
          onClick={close}
          variant="outlined"
          sx={{
            borderRadius: "20px 20px 0px 20px",
            borderColor: "primary.main",
            color: "primary.main",
            px: 3,
            py: 0.75,
            fontWeight: 530,
            fontSize: "1rem",
            borderWidth: "2px",
            width: { xs: "100%", md: "auto" },
            textTransform: "none",
            "&:hover": {
              bgcolor: "primary.main",
              color: "common.white",
              borderColor: "primary.main",
              borderWidth: "2px",
            },
          }}
        >
          Get in Touch
        </Button>
      </Box>
    </Box>
  );
}

export default Header;
